import { render } from "./dataobject-logs.vue?vue&type=template&id=99b3b2b6"
import script from "./dataobject-logs.vue?vue&type=script&lang=js"
export * from "./dataobject-logs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__